export default "__VITE_ASSET__RckqSc_A__"